import React, { useState, useCallback } from 'react';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

interface VideoProps {
  videoId: string;
  brandName: string;
  autoplay?: boolean;
  loop?: boolean;
  controls?: boolean;
}

const Video: React.FC<VideoProps> = ({ videoId, autoplay = true, loop = true }) => {
  const [isZoomed, setIsZoomed] = useState<boolean>(false);

  const handleZoomChange = useCallback((shouldZoom: boolean) => {
    setIsZoomed(shouldZoom);
    const metaViewport = document.querySelector('meta[name="viewport"]');
    if (metaViewport) {
      metaViewport.setAttribute(
        'content',
        shouldZoom
          ? 'width=device-width, initial-scale=1.0, maximum-scale=2.0, user-scalable=yes'
          : 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
      );
    }
  }, []);

  const cloudflareUrl = `https://iframe.videodelivery.net/${videoId}?autoplay=${autoplay ? 1 : 0}&loop=${
    loop ? 1 : 0
  }&controls=0${autoplay ? '&muted=1' : ''}`;

  return (
    <ControlledZoom isZoomed={isZoomed} onZoomChange={handleZoomChange}>
      <div style={{ position: 'relative', paddingTop: '100%' }}>
        <iframe
          src={cloudflareUrl}
          loading="lazy"
          style={{
            border: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            pointerEvents: 'none',
          }}
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowFullScreen={true}
        ></iframe>
      </div>
    </ControlledZoom>
  );
};

export default Video;
